<template>
  <div class="container py-5" id="myServices">
    <div class="mb-3">
      <h1 id="services">
        <span class="marker">My Services</span>
      </h1>
      <code>Approach your idea to reality</code>
    </div>

    <!-- Services -->
    <b-container class="text-center py-5 services-box">
      <b-row class="mb-5">
        <b-col class="service">
          <img class="img" src="https://cdn-icons-png.flaticon.com/512/5044/5044729.png" alt="Web App">
          <p class="my-4">Web Apps</p>
        </b-col>
        <b-col class="service">
          <img class="img"
            src="https://user-images.githubusercontent.com/3104648/28352004-a055292c-6c4b-11e7-9c6b-a94cdc2a5458.png"
            alt="PWA" />
          <p class="my-4">Progressive Web Apps</p>
        </b-col>
        <b-col class="service">
          <img class="img" src="https://cdn-icons-png.flaticon.com/512/2721/2721291.png" alt="RWD" />
          <p class="my-4">Responsive Web Design</p>
        </b-col>
      </b-row>
      <b-row class="mb-5">
        <b-col class="service">
          <img class="img" src="https://cdn-icons-png.flaticon.com/512/3607/3607459.png" alt="SEO">
          <p class="my-4">SEO</p>
        </b-col>
        <b-col class="service">
          <img class="img" src="https://cdn-icons-png.flaticon.com/512/7858/7858975.png" alt="UI/UX">
          <p class="my-4">Elegant UI/UX</p>
        </b-col>
        <b-col class="service">
          <img class="img" src="https://cdn-icons-png.flaticon.com/512/2956/2956433.png" alt="Web Accessibility">
          <p class="my-4">Web Accessibility</p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "MyServices"
};
</script>

<style lang="scss">
@import "@/assets/css/_variables.scss";

#myServices {
  #services {
    font-weight: 900;
    font-size: 3rem;
    text-transform: uppercase;

    @media all and (min-width: 720px) {
      font-size: 3.5rem;
    }
  }

  .service {
    // border: 1px solid #000;
    border-radius: 5px;
    margin: 5px;
    padding-top: 10px;

    .img {
      width: 4rem;
    }
  }
}
</style>
